
import {
  computed, defineComponent, onMounted, ref,
} from 'vue';
import { useRouter } from 'vue-router';
import { Form } from 'vee-validate';
import AppSelect from '@/components/UI/AppSelect.vue';
import AppButton from '@/components/UI/AppButton.vue';
import { useRegistrationStore } from '../store/registrationStore';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

export default defineComponent({
  components: {
    Form,
    AppSelect,
    AppButton,
  },
  setup() {
    const router = useRouter();
    const registrationStore = useRegistrationStore();
    const mainStore = useMainStore();

    const professionDetailValue = ref(registrationStore.createUser.professionSpeciality);

    const professionDetailList = computed(() => mainStore.professionDetail.professionals || []);

    function nextStep() {
      registrationStore.createUser.professionSpeciality = professionDetailValue.value;
      router.push('step-7');
    }

    onMounted(() => {
      if (!registrationStore.createUser.profession) {
        router.push('step-3');
      }
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      nextStep,
      professionDetailValue,
      professionDetailList,
      mainStore,
    };
  },
});
